"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setIsRunning = exports.update = exports.reset = exports.get = void 0;
var common_sidecar_1 = require("@main/common-sidecar");
var minigolfPhysics_rapier_loader_sidecar_1 = require("../physics/minigolfPhysics_rapier_loader-sidecar");
var minigolf_bufferedCommands_sidecar_1 = require("../simulation/minigolf_bufferedCommands-sidecar");
var namespace = 'physics-tick-manager';
var _obj = null;
var get = function () {
    if (!_obj) {
        _obj = {
            isRunning: false,
            physicsTickTimeMaxSeconds: minigolfPhysics_rapier_loader_sidecar_1.minigolfPhysics_rapier_loader.timestep,
            physicsTickTimeAccumulator: 0,
            isPhysicsTickFrame: false,
        };
        reset();
    }
    return _obj;
};
exports.get = get;
function reset(masterSeed) {
    if (masterSeed === void 0) { masterSeed = 0; }
    var obj = exports.get();
    obj.isRunning = false;
    obj.physicsTickTimeMaxSeconds = minigolfPhysics_rapier_loader_sidecar_1.minigolfPhysics_rapier_loader.timestep;
    obj.physicsTickTimeAccumulator = 0;
    obj.isPhysicsTickFrame = false;
}
exports.reset = reset;
function update() {
    var obj = exports.get();
    obj.isPhysicsTickFrame = false; // Reset tick frame signal
    if (!obj.isRunning) {
        // console.log(namespace, 'paused')
        obj.physicsTickTimeAccumulator = 0;
        return;
    }
    var maxUpdates = 5;
    var delta = common_sidecar_1.common.getUpdateDelta();
    var deltaMax = 1 / 10; // Cap delta at 10fps (6 frames at 60)
    if (delta > deltaMax) {
        delta = deltaMax;
    }
    obj.physicsTickTimeAccumulator += delta;
    while (maxUpdates-- > 0 &&
        obj.physicsTickTimeAccumulator > obj.physicsTickTimeMaxSeconds) {
        // Can update multiple ticks
        //if (obj.physicsTickTimeAccumulator > obj.physicsTickTimeMaxSeconds) {
        obj.physicsTickTimeAccumulator -= obj.physicsTickTimeMaxSeconds;
        obj.isPhysicsTickFrame = true;
        //}
        //if (obj.isPhysicsTickFrame) {
        // console.log(namespace, 'physics tick frame')
        // TODO: move this into a handler
        minigolfPhysics_rapier_loader_sidecar_1.minigolfPhysics_rapier_loader.updatePhysicsTick(true);
        minigolf_bufferedCommands_sidecar_1.minigolf_bufferedCommands.update();
        //}
    }
    // console.log('update')
    // if (
    //   obj.physicsTickTimeAccumulator > obj.frameTimeSeconds &&
    //   obj.currentSimuationFrame === obj.simulateToFrame // Make sure we are caught up
    // ) {
    //   obj.physicsTickTimeAccumulator -= obj.frameTimeSeconds
    //   obj.physicsTickTimeAccumulator = true
    //   // // Send out message to simulate next frame
    //   // obj.nextMessageSimulationFrame =
    //   //   obj.currentSimuationFrame + 1 + obj.simulationFrameDelay
    //   // extension_host_send_crc_and_simulation_frame()
    // }
}
exports.update = update;
function setIsRunning(isRunning) {
    var obj = exports.get();
    obj.isRunning = isRunning;
}
exports.setIsRunning = setIsRunning;
